import React from "react";
import style from "./style.module.scss";
import ChildTableRow from "./ChildTableRow";
import { formatCurrency } from "../../../../../../../../components/helper/helper";

function ChildTable({ data = [] }) {
  const toNumber = (value) => {
    const n =
      typeof value === 'string'
        ? Number(value.replace(/[^0-9.-]+/g, ''))
        : Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const getTotalTransactionAmount = () => {
    return data.reduce(
      (total, transaction) => total + toNumber(transaction.trans_amt),
      0,
    );
  };

  const getTotalNetAmount = () => {
    return data.reduce(
      (total, transaction) => total + toNumber(transaction.net_amt),
      0,
    );
  };

  const getTotalAdjAmount = () => {
    return data.reduce(
      (total, transaction) => total + toNumber(transaction.adj_amt),
      0,
    );
  };

  return (
    <tr className={style.child_row}>
      <td colSpan={11} className={style.child_row_cell}>
        <table className={style.child_table}>
          <thead>
            <tr className={`${style.child_header_row} ${style.line_after}`}>
              <th></th>
              <th>
                <div className={`${style.child_header_cell} ${style.br_left}`} title="Card Type">
                  Card type
                </div>
              </th>
              <th className={style.child_header_cell} title="Code">code</th>
              <th className={style.child_header_cell} title="Date">Date</th>
              <th className={style.child_header_cell} title="Key Entry">key entry</th>
              <th className={style.child_header_cell} title="Cardholder Account">cardholder acc.</th>
              <th className={style.child_header_cell} title="Authorization Number">Authorization No. </th>
              <th className={style.child_header_cell} title="Reference Number">Reference no.</th>
              <th className={style.child_header_cell} title="Voucher">Voucher</th>
              <th className={style.child_header_cell} title="Transaction Amount">Trans. amount</th>
              <th className={style.child_header_cell} title="Net Amount">Net amount</th>
              <th className={`${style.child_header_cell} ${style.br_right}`} title="Adjustment Amount">
                Adj. amount
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => {
              return (
                <ChildTableRow
                  data={row}
                  key={index}
                  lastRow={data?.length == index + 1}
                />
              );
            })}

            {/* total row */}
            <tr className={`${style.total_row}`}>
              <td className={style.child_table_cell} colSpan={2}>
                Transaction count:
              </td>
              <td className={style.child_table_cell}>{data?.length}</td>
              <td className={style.child_table_cell} colSpan={5}></td>
              <td className={style.child_table_cell}>Totals:</td>
              <td className={style.child_table_cell}>
                {getTotalTransactionAmount() ? `$ ${formatCurrency(getTotalTransactionAmount())}` : '0'}
              </td>
              <td className={style.child_table_cell}>
                {getTotalNetAmount() ? `$ ${formatCurrency(getTotalNetAmount())}` : '0'}
              </td>
              <td className={style.child_table_cell}>
                {getTotalAdjAmount() ? `$ ${formatCurrency(getTotalAdjAmount())}` : '0'}
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  );
}

export default ChildTable;
